<template>
  <div>
    <div class="audio">
      <audio controls>
        <source :src="step.clip" type="audio/mpeg" />
        Your browser does not support the audio tag.
      </audio>
      <p class="mt-2 mx-auto subtitle-2 blue-grey--text auto-width">
        {{ step.caption }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Audio",
  props: {
    step: Object
  }
};
</script>
